module.exports = __webpack_public_path__ + "img/huxing1.d567ea0a.jpg";